// 申込処理中止
import React from 'react';
import { render } from 'react-dom';
import Block from '../molecules/Block';
var ReceptionAbort = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-5" }),
        React.createElement(Block, { label: "\u7533\u8FBC\u51E6\u7406\u3092\u4E2D\u6B62\u3057\u307E\u3057\u305F\u3002", content: React.createElement("p", null,
                "\u7533\u8FBC\u51E6\u7406\u3092\u4E2D\u6B62\u3057\u307E\u3057\u305F\u3002",
                React.createElement("br", null),
                "\u518D\u958B\u3059\u308B\u5834\u5408\u306F\u3001\u901A\u77E5\u3055\u308C\u305F\u30E1\u30FC\u30EB\u306EURL\u3088\u308A\u30A2\u30AF\u30BB\u30B9\u3057\u3066\u304F\u3060\u3055\u3044\u3002") })));
};
if (document.getElementById('reception-abort')) {
    render(React.createElement(ReceptionAbort, null), document.getElementById('reception-abort'));
}
